import { render, staticRenderFns } from "./Undertime.vue?vue&type=template&id=456bfb55&scoped=true"
import script from "./Undertime.vue?vue&type=script&lang=js"
export * from "./Undertime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456bfb55",
  null
  
)

export default component.exports